import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-end',
    },
}))

const RightSection = ({ children }) => {
    const classes = useStyles()

    return <div className={classes.root}>{children}</div>
}

export default RightSection
